/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListingReference } from './ListingReference';
import {
    ListingReferenceFromJSON,
    ListingReferenceFromJSONTyped,
    ListingReferenceToJSON,
    ListingReferenceToJSONTyped,
} from './ListingReference';

/**
 * 
 * @export
 * @interface GetListingDetailsByMlsIdAv8Request
 */
export interface GetListingDetailsByMlsIdAv8Request {
    /**
     * 
     * @type {string}
     * @memberof GetListingDetailsByMlsIdAv8Request
     */
    operationName: GetListingDetailsByMlsIdAv8RequestOperationNameEnum;
    /**
     * 
     * @type {ListingReference}
     * @memberof GetListingDetailsByMlsIdAv8Request
     */
    listingReference: ListingReference;
}


/**
 * @export
 */
export const GetListingDetailsByMlsIdAv8RequestOperationNameEnum = {
    GetListingDetailsByMlsId: 'GetListingDetailsByMlsId'
} as const;
export type GetListingDetailsByMlsIdAv8RequestOperationNameEnum = typeof GetListingDetailsByMlsIdAv8RequestOperationNameEnum[keyof typeof GetListingDetailsByMlsIdAv8RequestOperationNameEnum];


/**
 * Check if a given object implements the GetListingDetailsByMlsIdAv8Request interface.
 */
export function instanceOfGetListingDetailsByMlsIdAv8Request(value: object): value is GetListingDetailsByMlsIdAv8Request {
    if (!('operationName' in value) || value['operationName'] === undefined) return false;
    if (!('listingReference' in value) || value['listingReference'] === undefined) return false;
    return true;
}

export function GetListingDetailsByMlsIdAv8RequestFromJSON(json: any): GetListingDetailsByMlsIdAv8Request {
    return GetListingDetailsByMlsIdAv8RequestFromJSONTyped(json, false);
}

export function GetListingDetailsByMlsIdAv8RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetListingDetailsByMlsIdAv8Request {
    if (json == null) {
        return json;
    }
    return {
        
        'operationName': json['operationName'],
        'listingReference': ListingReferenceFromJSON(json['listingReference']),
    };
}

export function GetListingDetailsByMlsIdAv8RequestToJSON(json: any): GetListingDetailsByMlsIdAv8Request {
    return GetListingDetailsByMlsIdAv8RequestToJSONTyped(json, false);
}

export function GetListingDetailsByMlsIdAv8RequestToJSONTyped(value?: GetListingDetailsByMlsIdAv8Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operationName': value['operationName'],
        'listingReference': ListingReferenceToJSON(value['listingReference']),
    };
}

